export type ImageData = {
  src: string;
  width?: number | string;
  style?: {};
};

const RoundImg: React.FC<ImageData> = (props) => {
  const baseStyle = {
    borderRadius: "50%",
    backgroundImage: "url(" + props?.src + ")",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: props.width ? props.width : 0,
    minWidth: props.width,
    aspectRatio: 1 / 1,
  };
  const style = {
    ...baseStyle,
    ...props.style,
  };
  return <div style={style} />;
};

export default RoundImg;
